import { createContext, useState } from 'react';

export const ConfirmationStageContext = createContext({
    confirmationStage: false,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setConfirmationStage: (_confirmationStage:boolean)=>{},
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ConfirmationStageProvider = ({children}: any) => {
    const [authUserConfirmationStage, setAuthUserConfirmationStage] = useState(false);
    const setConfirmationStage = (confirmationStage:boolean) => {
        setAuthUserConfirmationStage(confirmationStage);
    }

    const value = {
        confirmationStage: authUserConfirmationStage,
        setConfirmationStage: setConfirmationStage,
    }

    return(
        <ConfirmationStageContext.Provider value={value}>
            {children}
        </ConfirmationStageContext.Provider>
    )
}

export default ConfirmationStageProvider;